import { Flex } from '@bookjane2/bookjane-design-library';
import { P, H3 } from 'components/Typography';
import { useCustomFieldsSettingsComponentPropsContext } from 'pages/SettingsPage/CustomFieldsSettingsPage/contexts/CustomFieldsSettingsComponent.props.context';
import { useFetchCustomFieldsDataContext } from 'pages/SettingsPage/CustomFieldsSettingsPage/contexts/FetchCustomFields.data.context';
import {
  CUSTOM_FIELDS_SETTINGS_DESCRIPTION_EDIT,
  CUSTOM_FIELDS_SETTINGS_DESCRIPTION_VIEW,
  CUSTOM_FIELDS_SETTINGS_MAX_MESSAGE,
  MAX_CUSTOM_FIELDS,
} from 'pages/SettingsPage/CustomFieldsSettingsPage/CustomFieldsSettings.constants';
import {
  BKJIconWrapper,
  FlexWrapper,
  MaxNumberOfCustomFields,
} from 'pages/SettingsPage/CustomFieldsSettingsPage/CustomFieldsSettingsComponent/CustomFieldsSettingsComponent.styled';
import { CustomFieldsSettingsTable } from 'pages/SettingsPage/CustomFieldsSettingsPage/CustomFieldsSettingsComponent/CustomFieldsSettingsTable';
import { AddNewButton, SettingsPageWrapper } from 'pages/SettingsPage/SettingsPage.styled';
import { useEffect } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { queryRefetchService } from 'services/QueryRefetchService';

export function CustomFieldsSettingsComponent() {
  const { t } = useTranslation();

  const { isReadOnly, openCreateCustomFieldsModal } =
    useCustomFieldsSettingsComponentPropsContext();
  const { data: customFields = [], fetch } = useFetchCustomFieldsDataContext();

  useEffect(() => {
    queryRefetchService.addDataQuery('CUSTOM_FIELD', 'all', fetch as () => void);
    return () => queryRefetchService.removeDataQuery('CUSTOM_FIELD', 'all');
  }, []); // eslint-disable-line

  const isMaxCustomFields = customFields.length === MAX_CUSTOM_FIELDS;

  return (
    <FlexWrapper height="100%" width="100%">
      <SettingsPageWrapper>
        <Flex flexDirection="column" gap="32px">
          <H3 data-testid="hdr-customfields">{t('common:CUSTOM_FIELDS')}</H3>
          <P data-testid="msg-hdr-customfields">
            {isReadOnly
              ? t(CUSTOM_FIELDS_SETTINGS_DESCRIPTION_VIEW)
              : t(CUSTOM_FIELDS_SETTINGS_DESCRIPTION_EDIT)}
          </P>
          <CustomFieldsSettingsTable />
        </Flex>

        {isMaxCustomFields && (
          <MaxNumberOfCustomFields>{t(CUSTOM_FIELDS_SETTINGS_MAX_MESSAGE)}</MaxNumberOfCustomFields>
        )}

        {!isReadOnly && (
          <AddNewButton
            data-cy="btn-add-custom-field"
            variant={'PurpleText'}
            disabled={isMaxCustomFields}
            onClick={openCreateCustomFieldsModal}
          >
            <BKJIconWrapper
              iconName={'Add'}
              color={isMaxCustomFields ? 'TextDisabled' : 'PrimaryDefault'}
            />
            {t('settings:ADD_CUSTOM_FIELD')}
          </AddNewButton>
        )}
      </SettingsPageWrapper>
    </FlexWrapper>
  );
}
